import { createSelector } from '@reduxjs/toolkit';
import { GalleryComment } from '../models/galleryComment';
import { User } from '../models/user';
import { AppState, galleryCommentSelector, userSelector } from '../store/store';

export const selectFranchiseComments = createSelector([
    (state: AppState) => galleryCommentSelector.selectAll(state),
    (state: AppState) => userSelector.selectById(state, state.device.user?.id ?? 0)
], (galleryComments: GalleryComment[], _user?: User) => {
    return galleryComments.sort((a, b) => { return b.created?.localeCompare(a.created); });
});
